<template>
  <v-container class="pa-8 mt-8">
    <v-row>
      <v-col cols="12" class="pb-1">
        <h1 class="primary--text font-weight-bold">
          Instrucciones de evaluación
        </h1>
      </v-col>
      <v-col cols="12" class="pt-0">
        <span class="secondaryGray--text">
          Por favor, lee atentamente los detalles antes de comenzar tu prueba.
          Este entorno es seguro y cronometrado
        </span>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="8" order="1">
        <v-card rounded="lg" outlined class="pa-6">
          <v-row class="mt-1 mb-8" justify="center" align="center" no-gutters>
            <v-col cols="auto">
              <v-avatar color="primary" class="rounded-lg" size="48">
                <v-icon color="white">mdi-file-document</v-icon>
              </v-avatar>
            </v-col>
            <v-col cols="auto" class="cuestionario-info">
              <div class="primary--text">{{ instrucciones.nombre_tipo_evaluacion }}</div>
              <div class="primary--text font-weight-bold text-uppercase">
                {{ instrucciones.nombre }}
              </div>
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>

          <v-row>
            <v-col cols="12" sm="4" class="my-2">
              <div class="d-flex align-center secondaryGray--text mb-1">
                <v-icon size="20" color="secondaryGray" class="mr-1"
                  >mdi-clock-outline</v-icon
                >
                <span class="text-subtitle-2">Tiempo total</span>
              </div>
              <div class="primary--text font-weight-bold text-h6">
                {{ duracionFormateada }}
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="my-2">
              <div class="d-flex align-center secondaryGray--text mb-1">
                <v-icon size="20" color="secondaryGray" class="mr-1"
                  >mdi-help-box-multiple-outline</v-icon
                >
                <span class="text-subtitle-2">Preguntas</span>
              </div>
              <div class="primary--text font-weight-bold text-h6">
                {{ instrucciones.total_preguntas }}
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="my-2">
              <div class="d-flex align-center secondaryGray--text mb-1">
                <v-icon size="20" color="secondaryGray" class="mr-1"
                  >mdi-star-outline</v-icon
                >
                <span class="text-subtitle-2">Puntaje mínimo</span>
              </div>
              <div class="primary--text font-weight-bold text-h6">
                {{ instrucciones.nota_min }} / 10.0
              </div>
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>

          <div class="secondaryGray--text font-weight-bold mb-1">
            Indicaciones:
          </div>
          <div class="secondaryGray--text">
            {{ instrucciones.indicaciones }}
          </div>
        </v-card>

        <v-row class="mt-1">
          <v-col cols="12" sm="4">
            <v-card
              rounded="lg"
              outlined
              flat
              color="help-cards-color"
              class="pa-4"
              height="100%"
            >
              <span class="material-symbols-outlined">wifi</span>
              <div class="primary--text font-weight-bold">Conexión estable</div>
              <div class="secondaryGray--text">
                Usa una red de banda ancha confiable para evitar interrupciones
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="4">
            <v-card
              rounded="lg"
              outlined
              flat
              color="help-cards-color"
              class="pa-4"
              height="100%"
            >
              <span class="material-symbols-outlined">volume_off</span>
              <div class="primary--text font-weight-bold">
                Ambiente tranquilo
              </div>
              <div class="secondaryGray--text">
                Minimiza las distracciones para optimizar tu tiempo de respuesta
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="4">
            <v-card
              rounded="lg"
              outlined
              flat
              color="help-cards-color"
              class="pa-4"
              height="100%"
            >
              <span class="material-symbols-outlined">block</span>
              <div class="primary--text font-weight-bold">Evita recargar</div>
              <div class="secondaryGray--text">
                Recargar la página o cambiar de pestaña puede invalidar el
                progreso
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" md="4" order="2">
        <v-card rounded="lg" outlined class="pa-6">
          <div class="text-center">
            <div class="primary--text font-weight-bold text-h6">
              ¿Todo listo?
            </div>
            <div class="primary--text my-8">
              Al hacer clic en el botón, el temporizador comenzará
              inmediatamente. Asegúrate de estar preparado
            </div>
          </div>
          <v-btn
            color="primary"
            dark
            rounded
            block
            class="text-none mt-6"
            @click="onIniciarEvaluacion"
          >
            Iniciar evaluación
            <v-icon right small>mdi-play-outline</v-icon>
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "InstruccionesEvaluacion",
  data() {
    return {
      instrucciones: {
        id_solicitud_evaluacion: "",
        nombre: "",
        id_tipo_evaluacion: "",
        nombre_tipo_evaluacion: "",
        total_preguntas: 0,
        hora_duracion_eval: 0,
        minuto_duracion_eval: 0,
        nota_min: "",
        indicaciones: "",
      },
    };
  },
  computed: {
    duracionFormateada() {
      const partes = [];
      const horas = this.instrucciones.hora_duracion_eval;
      const minutos = this.instrucciones.minuto_duracion_eval;
      if (horas) partes.push(`${horas} ${horas === 1 ? 'hora' : 'horas'}`);
      if (minutos) partes.push(`${minutos} ${minutos === 1 ? 'minuto' : 'minutos'}`);
      return partes.join(' ');
    },
  },
  methods: {
    async getInstruccionesEvaluacion() {
      this.showLoader();
      try {
        const id_evaluacion = this.$route.params.idEvaluacion;
        const response =
          await this.services.evaluacionContratacion.getInstruccionesEvaluacion(
            id_evaluacion,
          );
        this.instrucciones = response?.data?.data;
      } catch (error) {
      } finally {
        this.hideLoader();
      }
    },
    onIniciarEvaluacion() {
      const id = this.$route.params.idEvaluacion;
      this.$router.push({ name: 'evaluacion-ejecucion', params: {idEvaluacion: id } })
    },
  },
  created() {
    this.getInstruccionesEvaluacion();
  },
};
</script>

<style scoped>
.help-cards-color {
  background-color: #f8f8f8;
}

.material-symbols-outlined {
  color: #1c1e4d;
}

.text-subtitle-2 {
  font-family: 'MuseoSans' !important;
}

.cuestionario-info {
  padding-left: 0 !important;
  padding-top: 16px !important;
  text-align: center !important;
}

@media (min-width: 497px) {
  .cuestionario-info {
    padding-left: 16px !important;
    padding-top: 0 !important;
    text-align: left !important;
  }
}
</style>
